import _ from 'underscore';

export default (defaultTourCriteria) => {
    const modifiedDefaultTourCriteria = _.omit(defaultTourCriteria, 'country');

    if (defaultTourCriteria.country) {
        modifiedDefaultTourCriteria.countries = [defaultTourCriteria.country];
    }

    return modifiedDefaultTourCriteria;
};